import Image from 'next/legacy/image';

import { H3, H5 } from '@common/headline';

import appleAndCinnamonPancakesPreview from '@public/img/how-it-works/apple-and-cinnamon-pancakes-preview.png';

export const DeliciousRecipes = (): JSX.Element => (
  <div className="mt-9 flex flex-col lg:mt-[94px] lg:flex-row lg:items-center">
    <div className="lg:w-[50%]">
      <div className="mx-3 lg:max-w-[450px]">
        <H3>Delicious recipes that encourage a celebration of eating</H3>
      </div>
      <div className="mx-3 mt-4 lg:max-w-[450px]">
        <H5>
          Access hundreds of delicious and balanced recipes that cater to all
          dietary preferences.
        </H5>
      </div>
    </div>
    <div className="mt-10 pl-1.5 lg:mt-0 lg:w-[50%] lg:pl-[5%]">
      <Image
        src={appleAndCinnamonPancakesPreview}
        width={1053}
        height={1104}
        alt="Apple and cinnamon pancakes"
      />
    </div>
  </div>
);
